// Libraries
import {
  Component,
  ViewChild
} from '@angular/core';
import { Router } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

// Components
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

// Services
import { QRService } from './../../services/qr.service';

// Interfaces
import { QRInformation } from './../../interfaces/qr-information.interface';

/**
 * `QRModalComponent` implements a view to show a modal with the QR for a given object
 */
@Component({
  selector: 'she-qr-modal',
  template: require('./qr-modal.component.html'),
  styles: [require('./qr-modal.component.scss')]
})
export class QRModalComponent {
  /**
   * Modal child
   */
  @ViewChild('QRModal')
  QRModal: any;

  /**
   * Current qr image
   */
  qrImageUrl: string;

  /**
   * Creates a new `QRModalComponent` instance.
   * @param modalSerive Service to open qr modal
   * @param qrService Service to communicate with the api
   * @param router Router object
   * @param toastr Show notification
   */
  constructor(
    private modalService: NgbModal,
    private qrService: QRService,
    private router: Router,
    private toastr: ToastsManager
  ) {}

  /**
   * Open qr modal
   * @param qrInformation data qr
   */
  public open(qrInformation: QRInformation): void {
    // Make request to get QR image
    this.qrService.get(qrInformation)
      .then((qrImageUrl) => {
        // Save data
        this.qrImageUrl = qrImageUrl;
        // Open Qr modal
        this.modalService.open(this.QRModal);
      })
      .catch(() => {
        // Redirect to extinguishers
        this.router.navigate(['extintores']);
        // Show message
        this.toastr.warning('QR no encontrado.', 'Advertencia!');
      });
  }

  /**
   * Show qr modal
   */
  public print(): void {
    window.print();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/admin/shared/components/qr-modal/qr-modal.component.ts